import type { Action } from 'react-sweet-state';

import type { FieldId } from '../../../../common/types/form/form-fields';
import type {
	FieldValue,
	ModifiedFieldValue,
} from '../../../../common/types/form/form-fields/field-values';
import { asModifiedFilesValue } from '../../../../common/types/form/form-fields/field-values/utils';
import { FormRendererLifecycleStage } from '../../../../common/types/lifecycle-handlers';
import type { FormRendererState } from '../../types';

export const updateModifiedValue =
	(fieldId: FieldId, modifiedFieldValue: ModifiedFieldValue): Action<FormRendererState> =>
	({ setState, getState }) => {
		const { lifecycleHandlers, modifiedValues } = getState();
		setState({
			modifiedValues: {
				...modifiedValues,
				[fieldId]: modifiedFieldValue,
			},
		});

		// Sanitise the modifiedValue so we don't leak internal state, e.g. `fileStatus`
		const modifiedFilesValue = asModifiedFilesValue(modifiedFieldValue);
		const fieldValue: FieldValue | null =
			modifiedFilesValue === undefined
				? modifiedFieldValue
				: modifiedFilesValue === null
					? null
					: { files: modifiedFilesValue.files };

		lifecycleHandlers[FormRendererLifecycleStage.FIELD_CHANGED]?.({
			fieldId,
			fieldValue,
			stage: FormRendererLifecycleStage.FIELD_CHANGED,
		});
	};
